export class LifecycleRegistry {
  private cleanups: Array<() => void> = [];
  private released = false;

  add(cleanup: () => void): () => void {
    if (this.released) {
      cleanup();
      return () => undefined;
    }
    this.cleanups.push(cleanup);
    return cleanup;
  }

  listen<K extends keyof DocumentEventMap>(target: Document, type: K, listener: (event: DocumentEventMap[K]) => void, options?: AddEventListenerOptions | boolean): void;
  listen<K extends keyof WindowEventMap>(target: Window, type: K, listener: (event: WindowEventMap[K]) => void, options?: AddEventListenerOptions | boolean): void;
  listen<K extends keyof HTMLElementEventMap>(target: HTMLElement, type: K, listener: (event: HTMLElementEventMap[K]) => void, options?: AddEventListenerOptions | boolean): void;
  listen(target: EventTarget, type: string, listener: EventListener, options?: AddEventListenerOptions | boolean): void;
  listen(target: EventTarget, type: string, listener: EventListener, options?: AddEventListenerOptions | boolean): void {
    target.addEventListener(type, listener, options);
    this.add(() => target.removeEventListener(type, listener, options));
  }

  release(): void {
    if (this.released) return;
    this.released = true;
    for (let index = this.cleanups.length - 1; index >= 0; index -= 1) this.cleanups[index]();
    this.cleanups.length = 0;
  }

  get size(): number { return this.cleanups.length; }
}
